module.exports = __webpack_public_path__ + "static/media/phone_bg_medium_large.953cfd18.png";